export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenConfigMst: {
        screenConfigMstId: 2,
        screenConfigMstUuid: "screenconfigmst002",
        screenConfigName: "コミュニティサポート系お知らせ一覧画面",
        deviceTypeName: "normal",
        serviceTypeName: "サービス名",
        screenOrientationKbn: 1,
        screenConifgStatus: 1,
        screenWidth: 1280,
        screenHeight: 800,
        screenLayout: {
          layoutHeader: [
            {
              uuid: "layoutHeader_1000000002_1",
              type: "header",
              logoImageUseFlg: true,
              lightOffBtnUseFlg: 0,
              btnCount: 3,
              btnLayoutType: 1,
              roundCornerFlg: 0,
              rectRoundCornerStyle: {
                roundCornerLeftTop: 0,
                roundCornerRightTop: 0,
                roundCornerLeftBottom: 0,
                roundCornerRightBottom: 0
              },
              zIndex: 0
            }
          ]
        }
      }
    }
  }
}